import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { LinkToAccountInvoice, LinkToAccountTerms, LinkToManageCards, LinkToTransactions } from './Links';

import './AccountLinksPanel.scss';

const className = 'arrow-links-panel';

export class AccountLinksPanel extends Component {
    render() {
        const {
            account: { reference, allowIncreaseLimit },
            accountCard,
        } = this.props;

        // Check if object is empty - if it is we have no card information.
        const hasCard = accountCard
            ? !(Object.keys(accountCard).length === 0 && accountCard.constructor === Object)
            : false;

        return (
            <div className={className}>
                <LinkToTransactions accountRef={reference} />
                <LinkToAccountInvoice accountRef={reference} />
                {hasCard && <LinkToManageCards accountRef={reference} allowIncreaseLimit={allowIncreaseLimit} />}
                <LinkToAccountTerms accountRef={reference} />
            </div>
        );
    }
}

AccountLinksPanel.propTypes = {
    account: PropTypes.object.isRequired,
    accountCard: PropTypes.object,
    hasInactiveCards: PropTypes.bool.isRequired,
};

AccountLinksPanel.defaultProps = {
    accountCard: {},
};
